import { useAuthStore } from "@/stores/auth";
import { PLAN_LIMITS, DOMAIN_LIMITS, RETENTION_DAYS, type Plan } from "@dmarc/shared";

/**
 * Hook to get the current organization's plan with related limits.
 * Provides null-safe access with "free" as the default plan.
 */
export function useCurrentPlan() {
  const { currentOrganization } = useAuthStore();

  const plan = (currentOrganization?.plan || "free") as Plan;

  return {
    plan,
    domainLimit: DOMAIN_LIMITS[plan],
    messageLimit: PLAN_LIMITS[plan].messages,
    retentionDays: RETENTION_DAYS[plan],
    isFree: plan === "free",
    isPaid: plan !== "free",
  };
}
